import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/shared/DesignSystem/Modal';
import styled from 'styled-components';
import { Button } from '@companycam/slab-web';

import { translate } from 'translations/i18n';

const StyledModal = styled(Modal)`
  width: 550px;
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 20px;
`;
const Msg = styled.p`
  font-weight: 600;
  font-size: 24px;
`;

const SuccessCheck = styled.i`
  font-size: 85px;
  margin-bottom: 20px;
  color: var(--cc_color_button_background_secondary);
`;

const ExportCompleteModal = ({ isOpen, onRequestClose, savedToDocuments }) => {
  return (
    <StyledModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="modal-content-wrap"
    >
      <ModalContainer>
        <SuccessCheck className="mdi mdi-file-clock" />
        <Msg>{translate('projects.taskList.exportPdf.completeMessage')}</Msg>
        <p className="instructions">
          {translate('projects.taskList.exportPdf.completeDescription')}

          {savedToDocuments ? (
            <>
              <br />
              {translate('projects.taskList.exportPdf.savedDescription')}
            </>
          ) : null}
        </p>
      </ModalContainer>

      <div className="btn-container">
        <Button color="primary" onClick={onRequestClose}>
          {translate('common.gotIt')}
        </Button>
      </div>
    </StyledModal>
  );
};

ExportCompleteModal.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
  savedToDocuments: PropTypes.bool,
};

export default ExportCompleteModal;
